import { render } from "./BackInStockSignupForm.vue?vue&type=template&id=55ea34fa&scoped=true"
import script from "./BackInStockSignupForm.vue?vue&type=script&lang=js"
export * from "./BackInStockSignupForm.vue?vue&type=script&lang=js"

import "./BackInStockSignupForm.vue?vue&type=style&index=0&id=55ea34fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ea34fa"]])

export default __exports__